import { render, staticRenderFns } from "./OrderFDItemEdit.vue?vue&type=template&id=308a88a4"
import script from "./OrderFDItemEdit.vue?vue&type=script&lang=js"
export * from "./OrderFDItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderFDItemEdit.vue?vue&type=style&index=0&id=308a88a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports